import { yearsSinceFounding } from '@/lib/utils';

/**
 * The academy's headline numbers — years of operation, branch/course/service
 * counts — gathered in one place so a real change (a branch opening or
 * closing, a course added) is a single edit instead of a hunt across every
 * page that quotes it.
 */
export const siteStats = {
  years: yearsSinceFounding(),
  branches: 3,
  courses: 40,
  services: 5,
};

const SMALL_NUMBER_WORDS = [
  'zero',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
];

/**
 * Spells out small counts for flowing prose — "three branches" reads better
 * inline than "3 branches". Falls back to the numeral past ten, since none
 * of this site's stats are written out that high.
 *
 * @param {number} n - The count to spell out.
 * @return {string} The word form, or the numeral if n is out of range.
 */
export function spellOutNumber(n: number): string {
  return SMALL_NUMBER_WORDS[n] ?? String(n);
}
